import Vue from 'vue'
import { debounce, range } from 'lodash'
import rfdc from 'rfdc'
const clone = rfdc()
const searchSortByDefault = 'A-Z'

const calculateUserPermissionID = (trackedBill, currentUser) => {
  if (trackedBill.IsSummary) {
    return 4
  } else if (trackedBill.TrackedBillAgencies && trackedBill.TrackedBillUsers) {
    var permissionOrder = [1, 0, 2, 3, 4]
    var roleOrder = [1, 5, 2, 3, 4]
    var userAgencies = currentUser.UserAgencies.map((x) => x.AgencyID)
    var agencyPermissions = trackedBill.TrackedBillAgencies.filter((x) =>
      userAgencies.includes(x.AgencyID)
    )
    var agencyPermission = null
    var userPermission = null
    var agencyUserRole = null
    agencyPermissions.sort((a, b) => {
      var ua = currentUser.UserAgencies.filter(
        (ua) => ua.AgencyID == a.AgencyID
      ).sort((a, b) => {
        return roleOrder.indexOf(a.AgencyRoleID) <
          roleOrder.indexOf(b.AgencyRoleID)
          ? -1
          : 1
      })
      var ub = currentUser.UserAgencies.filter(
        (ub) => ub.AgencyID == b.AgencyID
      ).sort((a, b) => {
        return roleOrder.indexOf(a.AgencyRoleID) <
          roleOrder.indexOf(b.AgencyRoleID)
          ? -1
          : 1
      })
      if (ua.length > 0 && ub.length > 0) {
        var highestARole = ua[0].AgencyRoleID
        var highestBRole = ub[0].AgencyRoleID
        var aPerm =
          roleOrder.indexOf(highestARole) <
            permissionOrder.indexOf(a.TrackedBillPermissionID)
            ? a.TrackedBillPermissionID
            : highestARole
        var bPerm =
          roleOrder.indexOf(highestBRole) <
            permissionOrder.indexOf(b.TrackedBillPermissionID)
            ? b.TrackedBillPermissionID
            : highestBRole
        return aPerm < bPerm ? -1 : 1
      }
    })
    var userPermissions = trackedBill.TrackedBillUsers.filter(
      (x) => x.UserID == currentUser.ID
    ).sort((a, b) => {
      return permissionOrder.indexOf(a.TrackedBillPermissionID) <
        permissionOrder.indexOf(b.TrackedBillPermissionID)
        ? -1
        : 1
    })
    if (agencyPermissions.length > 0) {
      agencyPermission = agencyPermissions[0]
    }
    if (userPermissions.length > 0) {
      userPermission = userPermissions[0]
    }
    if (agencyPermission && agencyPermission.AgencyID > 0) {
      var ua = currentUser.UserAgencies.filter(
        (ua) => ua.AgencyID == agencyPermission.AgencyID
      ).sort((a, b) => {
        return roleOrder.indexOf(a.AgencyRoleID) <
          roleOrder.indexOf(b.AgencyRoleID)
          ? -1
          : 1
      })
      if (ua.length > 0) {
        agencyUserRole = ua[0]
      }
    }
    var permissionID = null
    var roleID = null
    if (agencyPermission && agencyUserRole) {
      if (
        permissionOrder.indexOf(agencyPermission.TrackedBillPermissionID) <
        roleOrder.indexOf(agencyUserRole.AgencyRoleID)
      ) {
        roleID = agencyUserRole.AgencyRoleID
      } else {
        permissionID = agencyPermission.TrackedBillPermissionID
      }
    }
    if (userPermission) {
      if (permissionID) {
        permissionID =
          permissionOrder.indexOf(permissionID) <
            permissionOrder.indexOf(userPermission.TrackedBillPermissionID)
            ? permissionID
            : userPermission.TrackedBillPermissionID
      } else if (roleID) {
        permissionID =
          roleOrder.indexOf(roleID) <
            permissionOrder.indexOf(userPermission.TrackedBillPermissionID)
            ? roleID
            : userPermission.TrackedBillPermissionID
      } else {
        permissionID = userPermission.TrackedBillPermissionID
      }
    }
    return permissionID || roleID
  }
  return null
}

const trackedBill = {
  state: {
    trackedBills: [],
    trackedBillsPrivate: [],
    trackedBillsShared: [],
    trackedBillsSummary: [],
    selectedTrackedBill: {},
    selectedTrackedBillId: null,
    searchTotal: 0,
    searchCount: 0,
    searchPage: 1,
    searchSortBy: searchSortByDefault,
    searchDescending: false,
    searchRowsPerPage: 10,
    searchText: '',
    searchYear: new Date().getFullYear(),
    searchSpecialSession: null,
    searchPositions: [],
    searchConcerns: [],
    searchPriorities: [],
    searchAgencies: [],
    searchAssignedTo: [],
    searchBillStatus: [],
    searchDivisions: [],
    lookupText: '',
    saving: false,
  },

  getters: {
    trackedBills (state) {
      return state.trackedBills
    },
    selectedTrackedBill (state, getters, rootState, rootGetters) {
      // var trackedBill = clone(state.selectedTrackedBill)
      return state.selectedTrackedBill
    },
    selectedTrackedBillUsers (state, getters, rootState, rootGetters) {
      var trackedBill = clone(getters.selectedTrackedBill)
      if (trackedBill && trackedBill.ID > 0) {
        var users = []
        var permissionOrder = [1, 0, 2, 3, 4]
        var roleOrder = [1, 5, 2, 3, 4]
        if (
          trackedBill.TrackedBillAgencies &&
          trackedBill.TrackedBillAgencies.length > 0
        ) {
          trackedBill.TrackedBillAgencies.forEach((tba) => {
            let agencyPerm = tba.TrackedBillPermissionID
            tba.Agency.UserAgencies.forEach((ua) => {
              let match = users.findIndex((u) => u.ID == ua.UserID)
              var user = ua.User
              var perm =
                roleOrder.indexOf(ua.AgencyRoleID) <
                  permissionOrder.indexOf(agencyPerm)
                  ? agencyPerm
                  : ua.AgencyRoleID
              user.TrackedBillPermissionID = perm
              user.agency = tba.Agency
              user.agencyPerm = agencyPerm
              user.userAgencyBillPerm = perm
              user.agencyRole = ua.AgencyRoleID

              if (match == -1) {
                if (user.TrackedBillPermissionID != 4) {
                  users.push(user)
                }
              } else {
                var prev = users[match]
                if (
                  prev.TrackedBillPermissionID > user.TrackedBillPermissionID
                ) {
                  users[match].TrackedBillPermissionID =
                    user.TrackedBillPermissionID
                  users[match].agency = user.Agency
                  users[match].agencyPerm = agencyPerm
                  users[match].userAgencyBillPerm = user.userAgencyBillPerm
                  users[match].agencyRole = user.agencyRole
                }
              }
            })
          })
        }
        if (
          trackedBill.TrackedBillUsers &&
          trackedBill.TrackedBillUsers.length > 0
        ) {
          trackedBill.TrackedBillUsers.forEach((tbu) => {
            let match = users.findIndex((u) => u.ID == tbu.UserID)
            var user = tbu.User
            user.TrackedBillPermissionID = tbu.TrackedBillPermissionID
            if (match == -1) {
              if (user.TrackedBillPermissionID != 4) {
                users.push(user)
              }
            } else {
              var prev = users[match]
              if (prev.TrackedBillPermissionID > user.TrackedBillPermissionID) {
                users[match].TrackedBillPermissionID =
                  user.TrackedBillPermissionID
                users[match].directOverride = true
              }
            }
          })
        }
        return users
      } else {
        return []
      }
    },
    searchParameters (state) {
      return {
        pageNum: state.searchPage - 1,
        pageSize: state.searchRowsPerPage,
        sortProperty: state.searchSortBy,
        sortDirection: state.searchDescending ? 'desc' : 'asc',
        searchText: state.searchText,
        searchYear: state.searchYear,
        searchSpecialSession: state.searchSpecialSession,
        searchPositions: state.searchPositions,
        searchConcerns: state.searchConcerns,
        searchPriorities: state.searchPriorities,
        // searchAgencies: state.searchAgencies,
        searchAssignedTo: state.searchAssignedTo,
        searchBillStatus: state.searchBillStatus,
        searchDivisions: state.searchDivisions,
      }
    },
    loading (state) {
      return state.searchCount > 0
    },
  },

  mutations: {
    trackedBills (state, payload) {
      state.trackedBills = payload
    },
    trackedBillsShared (state, payload) {
      state.trackedBillsShared = payload
    },
    trackedBillsSummary (state, payload) {
      state.trackedBillsSummary = payload
    },
    trackedBillsPrivate (state, payload) {
      state.trackedBillsPrivate = payload
    },
    selectedTrackedBill (state, payload) {
      state.selectedTrackedBill = payload
    },
    selectedTrackedBillId (state, payload) {
      state.selectedTrackedBillId = payload
    },
    searchTotal (state, payload) {
      state.searchTotal = payload
    },
    searchCount (state, payload) {
      state.searchCount = payload
    },
    searchPage (state, payload) {
      state.searchPage = payload
    },
    searchSortBy (state, payload) {
      state.searchSortBy = payload
    },
    searchDescending (state, payload) {
      state.searchDescending = payload
    },
    searchRowsPerPage (state, payload) {
      state.searchRowsPerPage = payload
    },
    searchText (state, payload) {
      state.searchText = payload
    },
    searchYear (state, payload) {
      state.searchYear = payload
    },
    searchSpecialSession (state, payload) {
      state.searchSpecialSession = payload
    },
    searchPositions (state, payload) {
      state.searchPositions = payload
    },
    searchConcerns (state, payload) {
      state.searchConcerns = payload
    },
    searchPriorities (state, payload) {
      state.searchPriorities = payload
    },
    searchAgencies (state, payload) {
      state.searchAgencies = payload
    },
    searchAssignedTo (state, payload) {
      state.searchAssignedTo = payload
    },
    searchBillStatus (state, payload) {
      state.searchBillStatus = payload
    },
    searchDivisions (state, payload) {
      state.searchDivisions = payload
    },
    increaseSearchCount (state, payload) {
      state.searchCount = state.searchCount + 1
    },
    decreaseSearchCount (state, payload) {
      state.searchCount = state.searchCount - 1
    },
    setBillDetails (state, payload) {
      state.trackedBillsPrivate.forEach((item) => {
        if (
          item.BillNumber == payload.bill &&
          item.Year == payload.year &&
          item.SpecialSession == payload.specialSessionValue
        ) {
          item.billDetails = payload
        }
      })
      state.trackedBillsShared.forEach((item) => {
        if (
          item.BillNumber == payload.bill &&
          item.Year == payload.year &&
          item.SpecialSession == payload.specialSessionValue
        ) {
          item.billDetails = payload
        }
      })
      state.trackedBillsSummary.forEach((item) => {
        if (
          item.BillNumber == payload.bill &&
          item.Year == payload.year &&
          item.SpecialSession == payload.specialSessionValue
        ) {
          item.billDetails = payload
        }
      })
    },
    setBillDetailsInTrackedBillArray (state, payload) {
      let match = state.trackedBills.findIndex((b) => b.ID == payload.ID)
      if (match >= 0) {
        Vue.set(state.trackedBills, match, payload)
      }
    },
    lookupText (state, payload) {
      state.lookupText = payload
    },
    saving (state, payload) {
      state.saving = payload
    },
  },

  actions: {
    init (context, payload) {
      // load variables from local storage
      {
        let savedSetting = localStorage.getItem('billPositions')
        if (savedSetting != null && context.state.searchPositions.length == 0) {
          try {
            let prev = JSON.parse(savedSetting)
            context.commit('searchPositions', prev)
          } catch { }
        }
      }
      {
        let savedSetting = localStorage.getItem('billConcerns')
        if (savedSetting != null && context.state.searchConcerns.length == 0) {
          try {
            let prev = JSON.parse(savedSetting)
            context.commit('searchConcerns', prev)
          } catch { }
        }
      }
      {
        let savedSetting = localStorage.getItem('billPriorities')
        if (
          savedSetting != null &&
          context.state.searchPriorities.length == 0
        ) {
          try {
            let prev = JSON.parse(savedSetting)
            context.commit('searchPriorities', prev)
          } catch { }
        }
      }
      {
        let savedSetting = localStorage.getItem('billAssignedTo')
        if (
          savedSetting != null &&
          context.state.searchAssignedTo.length == 0
        ) {
          try {
            let prev = JSON.parse(savedSetting)
            if (prev) {
              let search = prev.join(' ')
              context.dispatch('user/setLookupText', search, {
                root: true,
              })
            }
            context.commit('searchAssignedTo', prev)
          } catch { }
        }
      }
      {
        let savedSetting = localStorage.getItem('billBillStatus')
        if (
          savedSetting != null &&
          context.state.searchBillStatus.length == 0
        ) {
          try {
            let prev = JSON.parse(savedSetting)
            context.commit('searchBillStatus', prev)
          } catch { }
        }
      }
      {
        let savedSetting = localStorage.getItem('billDivisions')
        if (savedSetting != null && context.state.searchDivisions.length == 0) {
          try {
            let prev = JSON.parse(savedSetting)
            context.commit('searchDivisions', prev)
          } catch { }
        }
      }
      {
        let savedSetting = localStorage.getItem('billSortBy')
        if (savedSetting != null) {
          try {
            let prev = JSON.parse(savedSetting)
            context.commit('searchSortBy', prev)
          } catch { }
        }
      }
    },
    lookupBounce: _.debounce((context) => {
      context.dispatch('lookupTrackedBills')
    }, 300),
    bounce: _.debounce((context) => {
      context.dispatch('searchTrackedBills')
    }, 1500),
    setSearchPage (context, payload) {
      if (payload != context.state.searchPage) {
        context.commit('searchPage', payload)
        context.dispatch('bounce', context)
      }
    },
    setSearchSortBy (context, payload) {
      if (payload != context.state.searchSortBy) {
        context.commit('searchSortBy', payload)
        localStorage.setItem('billSortBy', JSON.stringify(payload))
        context.dispatch('bounce', context)
      }
    },
    setSearchDescending (context, payload) {
      if (payload != context.state.searchDescending) {
        context.commit('searchDescending', payload)
        context.dispatch('bounce', context)
      }
    },
    setSearchRowsPerPage (context, payload) {
      if (payload != context.state.searchRowsPerPage) {
        context.commit('searchRowsPerPage', payload)
        context.dispatch('bounce', context)
      }
    },
    setSearchYear (context, payload) {
      if (payload != context.state.searchYear) {
        context.commit('searchYear', payload)
        context.dispatch('bounce', context)
      }
    },
    setSearchSpecialSession (context, payload) {
      if (payload != context.state.searchSpecialSession) {
        context.commit('searchSpecialSession', payload)
        context.dispatch('bounce', context)
      }
    },
    setSearchPositions (context, payload) {
      if (payload != context.state.searchPositions) {
        context.commit('searchPositions', payload)
        localStorage.setItem('billPositions', JSON.stringify(payload))
        context.dispatch('bounce', context)
      }
    },
    setSearchConcerns (context, payload) {
      if (payload != context.state.searchConcerns) {
        context.commit('searchConcerns', payload)
        localStorage.setItem('billConcerns', JSON.stringify(payload))
        context.dispatch('bounce', context)
      }
    },
    setSearchPriorities (context, payload) {
      if (payload != context.state.searchPriorities) {
        context.commit('searchPriorities', payload)
        localStorage.setItem('billPriorities', JSON.stringify(payload))
        context.dispatch('bounce', context)
      }
    },
    setSearchAgencies (context, payload) {
      if (payload != context.state.searchAgencies) {
        context.commit('searchAgencies', payload)
        context.dispatch('bounce', context)
      }
    },
    setSearchAssignedTo (context, payload) {
      if (payload != context.state.searchAssignedTo) {
        context.commit('searchAssignedTo', payload)
        localStorage.setItem('billAssignedTo', JSON.stringify(payload))
        context.dispatch('bounce', context)
      }
    },
    setSearchBillStatus (context, payload) {
      if (payload != context.state.searchBillStatus) {
        context.commit('searchBillStatus', payload)
        localStorage.setItem('billBillStatus', JSON.stringify(payload))
        context.dispatch('bounce', context)
      }
    },
    setSearchDivisions (context, payload) {
      if (payload != context.state.searchDivisions) {
        context.commit('searchDivisions', payload)
        localStorage.setItem('billDivisions', JSON.stringify(payload))
        context.dispatch('bounce', context)
      }
    },
    setSearchText (context, payload) {
      if (payload != context.state.searchText) {
        context.commit('searchText', payload)
        context.dispatch('bounce', context)
      }
    },
    setLookupText (context, payload) {
      if (payload != context.state.lookupText) {
        context.commit('lookupText', payload)
        context.dispatch('lookupBounce', context)
      }
    },
    setBillDetails (context, payload) {
      context.commit('setBillDetails', payload)
    },
    setSelectedTrackedBillId (context, payload) {
      context.commit('selectedTrackedBillId', payload)
    },
    setSelectedTrackedBillMatchingShared (context, payload) {
      let bills = JSON.parse(JSON.stringify(payload))
      bills = bills.map((trackedBill) => {
        var owningAgencies = trackedBill.TrackedBillAgencies.filter(
          (x) => x.TrackedBillPermissionID == 1
        )
          .map((x) => x.Agency)
          .filter((v, i, list) => {
            return list.findIndex((l) => l.ID == v.ID) === i
          })
        var userPermID = calculateUserPermissionID(
          trackedBill,
          context.rootState.auth.currentUser
        )
        return {
          ...trackedBill,
          currentUserPermissionID: userPermID,
          owningAgencies: owningAgencies,
        }
      })
      context.commit('selectedTrackedBillMatchingShared', bills)
    },
    setSelectedTrackedBill (context, payload) {
      let bill = JSON.parse(JSON.stringify(payload))
      context.commit('selectedTrackedBillId', bill.ID)
      var comments = bill.Comments || []
      var links = bill.Links || []
      var docs = bill.Documents || []
      var combined = comments
        .concat(
          links.map((link) => {
            return {
              ...link,
              link: link
                ? link.URL
                  ? link.URL.startsWith('http')
                    ? link.URL
                    : 'http://' + link.URL
                  : ''
                : '',
            }
          })
        )
        .concat(docs)
        .sort((a, b) => new Date(b.CreatedDate) - new Date(a.CreatedDate))
      var recent = combined.length > 0 ? combined[0] : null
      bill.recent = recent
      if (!bill.currentUserPermissionID) {
        bill.currentUserPermissionID = calculateUserPermissionID(
          bill,
          context.rootState.auth.currentUser
        )
      }
      context.commit('selectedTrackedBill', bill)
    },

    // loadTrackedBills(context, payload) {
    //   return new Promise((resolve, reject) => {
    //     const url = 'TrackedBill'
    //     context.commit('increaseSearchCount')
    //     var currentUser = context.rootState.auth.currentUser
    //     Vue.prototype.$axios.get(url).then(
    //       (res) => {
    //         var bills = res.data.map((trackedBill) => {
    //           var owningAgencies = trackedBill.TrackedBillAgencies.filter(
    //             (x) => x.TrackedBillPermissionID == 1
    //           ).map((x) => x.Agency)

    //           var userPermID = calculateUserPermissionID(
    //             trackedBill,
    //             currentUser
    //           )
    //           return {
    //             ...trackedBill,
    //             currentUserPermissionID: userPermID,
    //             owningAgencies: owningAgencies,
    //           }
    //         })
    //         context.commit('trackedBills', bills)
    //         context.commit('decreaseSearchCount')
    //         resolve(res)
    //       },
    //       (err) => {
    //         console.error(err)
    //         context.commit('decreaseSearchCount')
    //         context.dispatch('errors/handleError', err, { root: true })
    //         reject(err)
    //       }
    //     )
    //   })
    // },

    refreshSelectedTrackedBill (context, payload) {
      if (
        context.state.selectedTrackedBill &&
        context.state.selectedTrackedBill.ID > 0
      ) {
        context.dispatch(
          'loadSelectedTrackedBill',
          context.state.selectedTrackedBill.ID
        )
      }
    },
    async loadSelectedTrackedBill (context, payload) {
      if (
        context.state.selectedTrackedBill &&
        context.state.selectedTrackedBillId != payload &&
        context.state.selectedTrackedBill.ID != payload
      ) {
        context.commit('selectedTrackedBill', {})
        context.commit('selectedTrackedBillId', payload)
      }

      const url = 'TrackedBill/' + payload
      context.commit('increaseSearchCount')
      try {
        let res = await Vue.prototype.$axios.get(url)
        var trackedBill = res.data
        trackedBill.currentUserPermissionID = calculateUserPermissionID(
          trackedBill,
          context.rootState.auth.currentUser
        )
        trackedBill.owningAgencies = trackedBill.TrackedBillAgencies.filter(
          (x) => x.TrackedBillPermissionID == 1
        )
          .map((x) => x.Agency)
          .filter((v, i, list) => {
            return list.findIndex((l) => l.ID == v.ID) === i
          })
        context.dispatch('setSelectedTrackedBill', trackedBill)
        context.commit('decreaseSearchCount')
        return res
      } catch (err) {
        console.error(err)
        context.commit('decreaseSearchCount')
        context.dispatch('errors/handleError', err, { root: true })
        throw err
      }
    },
    async loadTrackedBillCardDetails (context, payload) {
      const url = 'TrackedBill/Card/' + payload
      var currentUser = context.rootState.auth.currentUser
      try {
        let res = await Vue.prototype.$axios.get(url)
        var bill = res.data
        var owningAgencies = bill.TrackedBillAgencies.filter(
          (x) => x.TrackedBillPermissionID == 1
        )
          .map((x) => x.Agency)
          .filter((v, i, list) => {
            return list.findIndex((l) => l.ID == v.ID) === i
          })
        var userPermID = calculateUserPermissionID(bill, currentUser)
        var combined = bill.Comments.concat(
          bill.Links.map((item) => {
            return {
              ...item,
              link: item.URL.startsWith('http')
                ? item.URL
                : 'http://' + item.URL,
            }
          })
        )
          .concat(bill.Documents)
          .sort((a, b) => new Date(b.CreatedDate) - new Date(a.CreatedDate))
        var recent = null
        if (combined.length > 0) {
          recent = combined[0]
        }
        let billDetails = {
          ...bill,
          recent,
          currentUserPermissionID: userPermID,
          owningAgencies: owningAgencies,
        }
        //set matching item in trackedBills array
        context.commit('setBillDetailsInTrackedBillArray', billDetails)
        return billDetails
      } catch (err) {
        console.error(err)
        context.dispatch('errors/handleError', err, { root: true })
        throw err
      }
    },
    searchTrackedBills (context, payload) {
      return new Promise((resolve, reject) => {
        if (!context.state.searchSortBy) {
          context.commit('searchSortBy', searchSortByDefault)
          context.commit('searchDescending', true)
        }
        if (Array.isArray(context.state.searchSortBy)) {
          if (context.state.searchSortBy.length > 0) {
            context.commit('searchSortBy', context.state.searchSortBy[0])
            context.commit(
              'searchDescending',
              context.state.searchDescending[0]
            )
          } else {
            context.commit('searchSortBy', searchSortByDefault)
            context.commit('searchDescending', true)
          }
        }
        if (!context.state.searchText) {
          context.commit('searchText', '')
        }
        context.commit('increaseSearchCount')
        var search = context.getters.searchParameters
        const url = `TrackedBill/Search`
        Vue.prototype.$axios.post(url, search).then(
          (res) => {
            //here we are checking to see if the request is what the current params are
            // we could also check to see if search == the current parameters
            if (
              JSON.stringify(context.getters.searchParameters) ==
              JSON.stringify(search)
            ) {
              var bills = res.data.Entries.map((trackedBill) => {
                var owningAgencies = trackedBill.TrackedBillAgencies.filter(
                  (x) => x.TrackedBillPermissionID == 1
                )
                  .map((x) => x.Agency)
                  .filter((v, i, list) => {
                    return list.findIndex((l) => l.ID == v.ID) === i
                  })
                var userPermID = calculateUserPermissionID(
                  trackedBill,
                  context.rootState.auth.currentUser
                )
                return {
                  ...trackedBill,
                  currentUserPermissionID: userPermID,
                  owningAgencies: owningAgencies,
                }
              })
              context.commit('trackedBills', bills)
              context.commit('searchRowsPerPage', res.data.Page.Size)
              context.commit('searchPage', res.data.Page.Number + 1)
              context.commit('searchTotal', res.data.Page.TotalElements)
            } else {
              console.devlog('no match')
            }
            context.commit('decreaseSearchCount')
            resolve(res)
          },
          (err) => {
            console.error(err)
            context.dispatch('errors/handleError', err, { root: true })
            context.commit('decreaseSearchCount')
            reject(err)
          }
        )
      })
    },
    lookupTrackedBills (context, payload) {
      if (context.state.lookupText) {
        return new Promise((resolve, reject) => {
          context.commit('increaseSearchCount')
          const url = `TrackedBill/Lookup?searchText=${context.state.lookupText}`
          Vue.prototype.$axios.get(url).then(
            (res) => {
              context.commit('trackedBills', res.data)
              context.commit('decreaseSearchCount')
              resolve(res)
            },
            (err) => {
              console.error(err)
              context.dispatch('errors/handleError', err, { root: true })
              context.commit('decreaseSearchCount')
              reject(err)
            }
          )
        })
      }
    },
    updateTrackedBill (context, payload) {
      return new Promise((resolve, reject) => {
        const url = `TrackedBill/${payload.ID}`
        context.commit('saving', true)
        Vue.prototype.$axios.put(url, payload).then(
          (res) => {
            context.dispatch(
              'messages/toastMessage',
              { color: 'success', message: 'tracked bill updated' },
              { root: true }
            )
            //if you will always need to reload the list after an update
            //you can uncomment out the following dispatch line.
            //Alternatively you can reload whatever object you need
            //when the promise resolves in the component that called it.
            //context.dispatch('loadTrackedBills')
            context.commit('saving', false)
            resolve(res)
          },
          (err) => {
            console.error(err)
            context.commit('saving', false)
            context.dispatch('errors/handleError', err, { root: true })
            reject(err)
          }
        )
      })
    },
    createTrackedBill (context, payload) {
      return new Promise((resolve, reject) => {
        const url = `TrackedBill`
        context.commit('saving', true)
        Vue.prototype.$axios.post(url, payload).then(
          (res) => {
            context.dispatch(
              'messages/toastMessage',
              { color: 'success', message: 'tracked bill created' },
              { root: true }
            )
            //if you will always need to reload the list after an item is created
            //you can uncomment out the following dispatch line.
            //Alternatively you can reload whatever object you need
            //when the promise resolves in the component that called it.
            //context.dispatch('loadTrackedBills')
            context.commit('saving', false)
            resolve(res)
          },
          (err) => {
            console.error(err)
            context.commit('saving', false)
            context.dispatch('errors/handleError', err, { root: true })
            reject(err)
          }
        )
      })
    },
    saveTrackedBill (context, payload) {
      return new Promise((resolve, reject) => {
        if (payload.ID > 0) {
          context.dispatch('updateTrackedBill', payload).then(
            (res) => resolve(res),
            (err) => reject(err)
          )
        } else {
          context.dispatch('createTrackedBill', payload).then(
            (res) => resolve(res),
            (err) => reject(err)
          )
        }
      })
    },
    deleteTrackedBill (context, payload) {
      return new Promise((resolve, reject) => {
        const url = `TrackedBill/${payload.ID}`
        Vue.prototype.$axios.delete(url).then(
          (res) => {
            context.dispatch(
              'messages/toastMessage',
              { color: 'success', message: 'tracked bill deleted' },
              { root: true }
            )
            //if you will always need to reload the list after a delete
            //you can uncomment out the following dispatch line.
            //Alternatively you can reload whatever object you need
            //when the promise resolves in the component that called it.
            //context.dispatch('loadTrackedBills')
            resolve(res)
          },
          (err) => {
            console.error(err)
            context.dispatch('errors/handleError', err, { root: true })
            reject(err)
          }
        )
      })
    },
  },
}

export default trackedBill
